import { useCallback, useEffect, useRef } from 'react';

export const usePlinkoSound = (muted, volume) => {
  const context = useRef(null), voices = useRef(new Set()), settings = useRef({});
  settings.current = { muted, level: Math.max(0, Math.min(100, Number(volume) || 0)) / 100 };
  const prepare = useCallback(() => {
    if (settings.current.muted || !settings.current.level) return null;
    try {
      const Audio = window.AudioContext || window.webkitAudioContext;
      if (!Audio) return null;
      const audio = context.current || (context.current = new Audio());
      audio.resume().catch(() => {});
      return audio;
    } catch { return null; }
  }, []);
  const play = useCallback((kind, value = 0) => {
    const audio = prepare();
    if (!audio || voices.current.size > 28) return;
    const tone = (frequency, delay, duration, level, type = 'sine', end = frequency * .92) => {
      const oscillator = audio.createOscillator(), gain = audio.createGain(), at = audio.currentTime + delay;
      oscillator.type = type; oscillator.frequency.setValueAtTime(frequency, at);
      oscillator.frequency.exponentialRampToValueAtTime(end, at + duration);
      gain.gain.setValueAtTime(.0001, at); gain.gain.linearRampToValueAtTime(level * settings.current.level, at + .004);
      gain.gain.exponentialRampToValueAtTime(.0001, at + duration);
      oscillator.connect(gain); gain.connect(audio.destination); voices.current.add(oscillator);
      oscillator.onended = () => { voices.current.delete(oscillator); oscillator.disconnect(); gain.disconnect(); };
      oscillator.start(at); oscillator.stop(at + duration + .01);
    };
    if (kind === 'drop') { tone(310, 0, .09, .075, 'triangle', 125); tone(1300, .01, .045, .018); }
    else if (kind === 'peg') tone(760 + value * 42, 0, .055, .026);
    else if (value >= 1) (value >= 10 ? [523, 659, 784, 1047] : [523, 659, 784]).forEach((frequency, index) => tone(frequency, index * .055, .23, .045));
    else tone(280, 0, .16, .065, 'triangle', 180);
  }, [prepare]);
  useEffect(() => {
    if (muted || !Number(volume)) voices.current.forEach((voice) => { try { voice.stop(); } catch { /* Already stopped. */ } });
  }, [muted, volume]);
  useEffect(() => () => { context.current?.close().catch(() => {}); context.current = null; }, []);
  return { prepare, play };
};